import React from "react";
import { shouldAddError } from "../../../helpers/Functions";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorResponse: null, errorNum: 0 };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.

    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    const errorInfo = {
      errorMessage: error?.message || "",
      stackTrace: error?.stack || "",
      fullUrl: window?.location?.href || "",
      userAgent: navigator.userAgent,
      timestamp: Date.now() || "",
      timezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || "",
      referrer: document.referrer,
      screenSize: `${window?.innerWidth || ""} x ${window?.innerHeight || ""}`, // browser window size
      resolution: `${
        window?.screen?.width * window?.devicePixelRatio || ""
      } x ${window?.screen?.height * window?.devicePixelRatio || ""}`, // device resolution
      locale: window?.navigator?.language || ""
    };
    //if it's a new error (not already seen in a sibling component) add it to list
    if (!!shouldAddError(this.props.frontendErrors, errorInfo))
      this.props.setFrontendErrors([
        ...(this?.props?.frontendErrors || []),
        errorInfo
      ]);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
